import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export const Checkbox = ({ className, ...rest }) => (_jsx("input", { className: classNames(className, "cvr-control"), type: "checkbox", ...rest }));
